import * as http from '../utils/request'

//GET /area/getAreaByCityId
// 根据市获取地区
//
// GET /area/getCityByProvId
// 根据省获取市
//
// GET /area/getProvCityList
// 获取省市级联
//
// GET /area/getProvList
// 获取省列表


export function getAreaByCityId(cityId) {
  return http.get("/area/getAreaByCityId",{cityId});
}

export function getCityByProvId(provId) {
  return http.get("/area/getCityByProvId",{provId});
}

export function getProvCityList() {
  return http.get("/area/getProvCityList");
}


export function getProvList() {
  return http.get("/area/getProvList");
}



// WEBPACK FOOTER //
// ./src/services/area.js